import React from "react";
import { crd } from "../../constants/styles";

/**
 * Expanded fit insights card for property detail page.
 * Shows: fit label, tag pills, strengths ("why this may fit"), cautions ("check before deciding").
 * Props: { fit, t, h }
 */
export default function FitInsights({ fit, t, h }) {
  if (!fit) return null;

  return <div style={crd(h)}>
    {/* Header: label + score context */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: fit.color, flexShrink: 0 }} />
        <span style={{ color: fit.color, fontWeight: 700, fontSize: 14 }}>{fit.label}</span>
      </div>
      <span style={{ color: h.sc, fontSize: 10 }}>{t.fitSuitability || "Suitability"}</span>
    </div>

    {/* Tags row */}
    {fit.tags.length > 0 && <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 10 }}>
      {fit.tags.map((tag, i) => <span key={i} style={{
        background: `${fit.color}10`, color: fit.color, padding: "2px 8px",
        borderRadius: 10, fontSize: 10, fontWeight: 500
      }}>{tag}</span>)}
    </div>}

    {/* Strengths: "Why this may fit" */}
    {fit.strengths.length > 0 && <div style={{ marginBottom: fit.cautions.length > 0 ? 10 : 0 }}>
      <div style={{ color: h.gn, fontSize: 11, fontWeight: 600, marginBottom: 5 }}>{"✓ " + (t.fitWhyFit || "Why this may fit")}</div>
      {fit.strengths.map((s, i) => <div key={i} style={{ color: h.tx, fontSize: 11, lineHeight: 1.6, paddingLeft: 12 }}>• {s}</div>)}
    </div>}

    {/* Cautions: "Check before deciding" */}
    {fit.cautions.length > 0 && <div>
      <div style={{ color: h.wn, fontSize: 11, fontWeight: 600, marginBottom: 5 }}>{"⚠ " + (t.fitCheckBefore || "Check before deciding")}</div>
      {fit.cautions.map((c, i) => <div key={i} style={{ color: h.sc, fontSize: 11, lineHeight: 1.6, paddingLeft: 12 }}>• {c}</div>)}
    </div>}

    {/* Disclaimer */}
    <div style={{ color: h.sc, fontSize: 9, marginTop: 8, opacity: 0.7 }}>{t.fitDisclaimer || "Based on listed property details. Verify in person."}</div>
  </div>;
}
